import { translate } from "../../utils/translation";
import PropTypes from "prop-types";
import UploadModal from "../common/UploadModal.components";

export default function CostPlanningUploader(props) {
  const { data } = props;
  const { uploadFunction } = props;
  const { isAreaSchedule } = props;

  return (
    <div className="pdu-container">
      <AreaScheduleLink isAreaSchedule={isAreaSchedule} />
      <UploadModal data={data} uploadFunction={uploadFunction} />
    </div>
  );
}

AreaScheduleLink.propTypes = {
  isAreaSchedule: PropTypes.bool,
};

function AreaScheduleLink(props) {
  const { isAreaSchedule } = props;

  if (!isAreaSchedule) {
    return null;
  }

  return (
    <div className="cost-planning-upload-control-row">
      <div className="cost-planning-upload-control-label">
        {translate("Area Schedule Template")}:
      </div>
      <a
        className="cost-planning-upload-document-button"
        href={
          "https://stcostclarityprd001.blob.core.windows.net/1-guides/Cost Clarity - Area Schedule Template.xlsx"
        }
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        {translate("Download")}
      </a>
    </div>
  );
}
